module.exports = ".pointer {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/deviceStatusTable/devicesStatusTable.component.scss
// module id = ./src/app/components/common/deviceStatusTable/devicesStatusTable.component.scss
// module chunks = main